import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { Footer, FooterButtons } from '@/design_system/Footer';
import { ShipmentWithRelations, useCompleteFinalisation } from '@/models/shipment';

const FinalisationAction = ({
  shipment,
  onFinalisationDone,
}: {
  shipment: ShipmentWithRelations;
  onFinalisationDone: () => void;
}) => {
  const {
    mutateAsync: completeFinalisation,
    isPending: isCompleteFinalisationPending,
    isSuccess: isCompleteFinalisationSuccess,
  } = useCompleteFinalisation();

  return (
    <Footer>
      <FooterButtons>
        <Button
          variant="primary"
          onPress={async () => {
            await completeFinalisation(shipment.id);
            onFinalisationDone();
          }}
          isLoading={isCompleteFinalisationPending || isCompleteFinalisationSuccess}
        >
          <Trans id="shipment.ready-for-handover">Mark package finalisation as done</Trans>
        </Button>
      </FooterButtons>
    </Footer>
  );
};

export default FinalisationAction;
